//示例，根据项目修改或重新创建
import https from "../https";
import config from "@/config";

export default {
  getList(params) {
    return https.get(`${config.baseUrl}/api/info/list`, params);
  },
  getNode(params) {
    return https.get(`${config.baseUrl}/api/info/getByNode`, params);
  },
  getById(params) {
    return https.get(`${config.baseUrl}/api/info/getById`, params);
  },
  getFulltext(params) {
    return https.get(`${config.baseUrl}/api/fulltext/list`, params);
  },
  getJK(params) {
    return https.post(`${config.baseUrl3}/api/donate/portal/saveOnlineDonatePc`, params);
  },
  getJKapp(params) {
    return https.post(`${config.baseUrl3}/api/donate/portal/saveOnlineDonate`, params);
  },
  getJjList(params) {
    return https.get(`http://scredcross.com:8087/cms/api/info/list?node=jzxm&pageSize=50`, params);
  },
};
